export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Search courses and categories"])}
        },
        "courses": {
          "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No courses found for your query"])},
          "notEnrolled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You are not enrolled in any courses yet"])},
          "goToCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Go to the course catalog"])}
        }
      },
      "ru": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Поиск по курсам и категориям"])}
        },
        "courses": {
          "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курсов по вашему запросу не найдено"])},
          "notEnrolled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Вы пока не зачислены на курсы"])},
          "goToCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Перейти в каталог курсов"])}
        }
      },
      "es": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Buscar en cursos y categorías"])}
        },
        "courses": {
          "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["No se encontraron cursos para su solicitud"])},
          "notEnrolled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aún no estás matriculado en ningún curso"])},
          "goToCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ir al catálogo de cursos"])}
        }
      },
      "kk": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курстар мен категориялар бойынша іздеу"])}
        },
        "courses": {
          "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сіздің сұрауыңыз бойынша курс табылмады"])},
          "notEnrolled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Сіз әлі курстарға жазылмағансыз"])},
          "goToCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Курстар каталогына өту"])}
        }
      },
      "uz": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurslar va kategoriyalar bo'yicha qidiruv"])}
        },
        "courses": {
          "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sizning so'rovingiz bo'yicha kurslar topilmadi"])},
          "notEnrolled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Siz hozircha kurslarga yozilmagansiz"])},
          "goToCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kurslar katalogiga o'ting"])}
        }
      },
      "de": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Suche nach Kursen und Kategorien"])}
        },
        "courses": {
          "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Keine Kurse für Ihre Suche gefunden"])},
          "notEnrolled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Sie sind noch in keine Kurse eingeschrieben"])},
          "goToCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Zum Kurskatalog gehen"])}
        }
      },
      "fr": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Recherche par cours et catégories"])}
        },
        "courses": {
          "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aucun cours trouvé pour votre recherche"])},
          "notEnrolled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vous n'êtes pas encore inscrit à des cours"])},
          "goToCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Aller au catalogue des cours"])}
        }
      },
      "it": {
        "search": {
          "placeholder": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ricerca nei corsi e nelle categorie"])}
        },
        "courses": {
          "notFound": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nessun corso trovato per la tua ricerca"])},
          "notEnrolled": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Non sei ancora iscritto ai corsi"])},
          "goToCatalog": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vai al catalogo dei corsi"])}
        }
      }
    }
  })
}
